<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal" :widthModal="1050">
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
        Dados Usuário Web - {{ item.jsonData ? item.jsonData.fullName : '' }}
        <v-spacer></v-spacer>
        <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <div class="abas" style="width: 95%;">
          <v-tabs
            v-model="tab"
            background-color="#FFF"
            height="30px">
            <v-tab href="#tab-1" class="abas-item">
              Dados pessoais
            </v-tab>
            <!-- <v-tab
              href="#tab-2"
              class="abas-item"
              @click="openPremioModal">
              Prêmios
            </v-tab> -->
            <!-- <v-tab
              href="#tab-3"
              class="abas-item">
              Dados bancário
            </v-tab> -->
            <v-tab
              href="#tab-4"
              class="abas-item"
              @click="openExtratoCreditoModal">
              Extrato
            </v-tab>
            <!-- <v-tab
              href="#tab-5"
              class="abas-item"
              @click="openTitulosCapitalizacao">
              Titulos Capitalização
            </v-tab> -->
             <!-- <v-tab
              href="#tab-6"
              class="abas-item"
              @click="openExtratoPremioModal">
              Extrato Prêmios
            </v-tab> -->

             <v-tab
              href="#tab-7"
              class="abas-item"
              @click="openExtratoJogosModal">
              Extrato Jogos
            </v-tab>

             <v-tab
              href="#tab-8"
              class="abas-item"
              @click="openListaJogosCassinos">
              Extrato Jogos Cassino
            </v-tab>
          </v-tabs>
        </div>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item
          :value="'tab-1'">
          <v-col class="d-flex justify-center align-center" style="min-height: 300px; width: 100%;" v-if="loaderModal">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-col>

          <dadosPessoais
            @closeModal="closeModal"
            :data="dataUser"
            :key="keyDados"
            v-if="!loaderModal" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-2'">
          <premios @closeModal="closeModal" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-3'">
          <dadosBancario @closeModal="closeModal" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-4'">
          <extratoCredito
          @closeModal="closeModal" 
          @updatedRangeDate="setDateRange"
          @obterExtratoPorData="obterExtratoPorData" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-5'">
          <titulosCapitalizacao @closeModal="closeModal" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-6'">
          <extratoPremio @closeModal="closeModal" />
        </v-tab-item>
        <v-tab-item
          :value="'tab-7'">
          <extratoJogos
            @closeModal="closeModal"
            @updatedRangeDate="setDateRange"
            @obterJogosPorData="obterJogosPorData"
          />
        </v-tab-item>

        <v-tab-item
          :value="'tab-8'">
          <extratoCassino
            @closeModal="closeModal"
            @updatedRangeDate="setDateRange"
            @obterJogosPorData="obterJogosPorDataCassino"
            @obterJogosPorIdAposta="obterJogosPorIdAposta"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Events from '@/core/service/events'
import { mask } from 'vue-the-mask'
import variables from '@/assets/styles/helpers/_variables.scss'
import moment from 'moment'
import { cloneDeep } from 'lodash'

export default {
  name: 'ModalUsuarioWeb',
  components: {
    dadosPessoais: () => import('./formDadosPessoais'),
    premios: () => import('./formPremios'),
    dadosBancario: () => import('./formDadosBancario'),
    extratoCredito: () => import('./extratoCredito'),
    titulosCapitalizacao: () => import('./titulosCapitalizacao'),
    extratoPremio: () => import('./extratoPremio'),
    extratoJogos: () => import('./extratoJogos'),
    extratoCassino: () => import('./extratoCassino'),
    Modal: () => import('../modal')
  },
  mixins: [validationMixin],
  directives: {
    mask
  },
  data: () => ({
    activeModal: false,
    tab: 'tab-1',
    loaderModal: false,
    id: '',
    dataUser: '',
    rangeDate: {
      start: moment().add(-7, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    page: 1,
    keyDados: 1,
  }),
  mounted () {
    Events.$on('cadastro::openModalCadastro', item => {
      if (this.id !== item.id) {
        this.id = item.id
        // this.loaderModal = true
        // this.getUserToId({ id: item.id })
        //   .finally(() => this.loaderModal = false)
        const cloneItem = cloneDeep(item)
        cloneItem.jsonData.password = ''
        this.setItem(cloneItem)
        this.dataUser = this.item
        this.cleanPassword()
        Events.$emit('validarCloseModel')
        this.openModal()
        this.keyDados += 1
      }

    })
  },
  computed: {
    ...mapGetters('usuariosWeb', {
      item: 'item',
      totalItens: 'totalItens',
    }),
    ...mapGetters('roles', ['permiteAcao']),

    variables: () => variables,
  },
  methods: {
    ...mapActions('usuariosWeb', ['getItens','cleanPassword', 'setItem', 'deletarItem', 'clearItens', 'getItem', 'editSaveItem', 'setLoadingTable', 'getDocuments', 'getExtratoCredito', 'getExtratoPremio', 'getUserToId', 'getExtratoJogos', 'getJogosCassino']),
    openModal () {
      this.activeModal = true
    },
    openPremioModal () {
      let self = this
      self.setLoadingTable(true)
      self.getDocuments(this.item).then(() => {
        self.setLoadingTable(false)
      })
    },
    openExtratoCreditoModal () {
      let self = this
      self.setLoadingTable(true)
      this.getExtratoCredito({ entityId: self.dataUser.id, dtInicial: self.rangeDate.start, dtFinal: self.rangeDate.end, pageSize: self.$store.getters.ItensPaginacao, page: self.page})
        .then (() => {
          self.setLoadingTable(false)
        })
    },
    openTitulosCapitalizacao () {
      let self = this
      self.setLoadingTable(true)
      this.getExtratoCredito(this.dataUser).then (() => {
        self.setLoadingTable(false)
      })
    },
    openExtratoPremioModal () {
      let self = this
      self.setLoadingTable(true)
      this.getExtratoPremio(this.dataUser).then (() => {
        self.setLoadingTable(false)
      })
    },
    openExtratoJogosModal () {
      let self = this
      self.setLoadingTable(true)
      this.getExtratoJogos({ entityId: self.dataUser.id, dtInicial: self.rangeDate.start, dtFinal: self.rangeDate.end, pageSize: self.$store.getters.ItensPaginacao, page: self.page})
        .finally (() => {
          self.setLoadingTable(false)
        })
    },

    openListaJogosCassinos () {
      let self = this
      self.setLoadingTable(true)
      this.getJogosCassino({ entityId: self.dataUser.id, dtInicial: self.rangeDate.start, dtFinal: self.rangeDate.end, pageSize: self.$store.getters.ItensPaginacao, page: self.page})
        .finally (() => {
          self.setLoadingTable(false)
        })
    },
    closeModal () {
      this.clearItens()
      this.activeModal = false
      this.tab = 'tab-1'
      this.id = ''
    },

    setDateRange(rangeDate) {
      this.rangeDate = rangeDate
    },

    obterExtratoPorData (rangeDate, page) {
      this.rangeDate = rangeDate
      this.page = page
      this.openExtratoCreditoModal()
    },

    obterJogosPorData (rangeDate, page) {
      this.rangeDate = rangeDate
      this.page = page
      this.openExtratoJogosModal()
    },

    obterJogosPorDataCassino (rangeDate, page) {
      this.rangeDate = rangeDate
      this.page = page
      this.openListaJogosCassinos()
    },

    obterJogosPorIdAposta (idAposta) {
      // this.openListaJogosCassinos()
      this.getJogosCassino({ idAposta })
        .finally (() => {
          self.setLoadingTable(false)
        })
    }
  }
}
</script>

<style lang="scss" src="./style.scss"></style>
